import { render } from "./IconPlus.vue?vue&type=template&id=aa457184"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"
script.render = render

export default script